// components
import AudioModal from "../modals/player/AudioModal";

// arrays
import { LatestRelease, Singles } from "../../arrays/DiscographyLists";

// hooks
import { useModalManager } from "../../hooks/useModalManager";

function Discography() {
    const {
        isVisible,
        showModal,
        hideModal,
        currentModal,
        setCurrentModal
    } = useModalManager();

    return (
        <div className="wrapper">
            <div className="discography">
                <h2>Latest Release</h2>
                <div className="discographyBlock latest">
                    {LatestRelease.cover.image}
                    <div className="recordBody">
                        <div className="recordHeading">
                            <div>
                                <h3>{LatestRelease.title}</h3>
                                <p className="italic">{LatestRelease.slogan}</p>
                            </div>
                            <div className="rightAlign">
                                <p>{LatestRelease.duration}</p>
                                <p>{LatestRelease.albumOrSingle}</p>
                            </div>
                        </div>
                        <ul>
                            {
                                LatestRelease.embeds.map((embed, i) => {
                                    return (
                                        <li key={i}>
                                            <button onClick={() => {
                                                setCurrentModal({
                                                    id: embed.id,
                                                    track: embed.videoID,
                                                    title: LatestRelease.title
                                                })
                                                showModal();
                                            }}>
                                                {embed.caption}
                                            </button>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                    <ul className="latestLinks rightAlign">
                        {
                            LatestRelease.links.map(link => {
                                return (
                                    <li>
                                        <a href={link.link}>
                                            {link.icon}
                                            {link.platform}
                                        </a>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
                <h2>Singles</h2>
                {
                    Singles.map(single => {
                        return (
                            <div className="discographyBlock single">
                                {single.cover.image}
                                <div className="recordBody">
                                    <div className="recordHeading">
                                        <h3 className="leftAlign">{single.title}</h3>
                                        <p className="italic slogan">{single.slogan}</p>
                                        <p className="duration rightAlign">{single.duration}</p>
                                    </div>
                                    <ul className="embedList">
                                        {
                                            single.embeds.map((embed, i) => {
                                                return (
                                                    <li key={i}>
                                                        <button onClick={() => {
                                                            setCurrentModal({
                                                                id: embed.id,
                                                                track: embed.videoID,
                                                                title: single.title
                                                            })
                                                            showModal();
                                                        }}>
                                                            {embed.caption}
                                                        </button>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>

                                    {/* TODO collapsible: More ways to Listen & Watch */}
                                    <details name={`links-${single.id}`}>
                                        <summary>More Ways to Listen:</summary>
                                        <ul>
                                            {
                                                single.links.map((link, i) => {
                                                    return (
                                                        <li key={i}>
                                                            <a href={link.link}>
                                                                {link.icon}
                                                                {link.platform}
                                                            </a>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </details>
                                    {
                                        single.videos.length > 0 ?
                                            <details name={`links-${single.id}`}>
                                                <summary>More Ways to Watch:</summary>
                                                <ul>
                                                    {
                                                        single.videos.map((video, i) => {
                                                            return (
                                                                <li key={i}>
                                                                    <a href={video.link}>
                                                                        {video.icon}
                                                                        {video.type}
                                                                    </a>
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </details>
                                        :
                                            ""
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            {isVisible && (
                <AudioModal
                    id={currentModal.id}
                    track={currentModal.track}
                    title={currentModal.title}
                    isVisible={isVisible}
                    onClose={() => hideModal()}
                />
            )}
        </div>
    );
}

export default Discography;